'use strict';

import { clamp, createHtmlElement } from '../../../functions';
import JSShare from "../../../libs/share/jsshare";
import { isDesktop, isMobile, isTablet, settingsData } from '../../../settings';
import {BaseElement} from "../../interfaces/BaseElement";
import { DropDown } from '../../interfaces/DropDown';
import { changeLangToCurrent, getCurrentLangDirection } from '../langSwitcher/langSwitcher';
import Notiflix from 'notiflix';
import Hammer from 'hammerjs';


export class SocialMedia {

    constructor (parent, urlType,overflow = true,openPosition = 'auto') {
        if (!config.features.socialMedia?.active) return;

        this.parent = parent;
        this.overflow = overflow;
        this.position = openPosition;
        // this.btn = createHtmlElement(this.parent,'','div',['social-media-btn','icon-share']);
        this.btn = new BaseElement()
            .addClass('social-media-btn','icon-share')
            .appendTo(this.parent);

        switch (urlType) {
            case 'domain':
                this.url = new URL(window.location.href).origin;
                break;
            case 'apt':
                if (!settingsData.lastClickedFlat.userData?.crm_data.bmbyPropID) {
                    setTimeout(() => {
                        this.url = new URL(window.location.href).origin + `/?card=${settingsData.lastClickedFlat.userData.crm_data.bmbyPropID}`;
                    }, 1000);
                } else {
                    this.url = new URL(window.location.href).origin + `/?card=${settingsData.lastClickedFlat.userData.crm_data.bmbyPropID}`;
                }
                break;
        }

        // this.closeHandler = this.#closeHandler.bind(this);
        this.btn.event('click', this.#openHandler.bind(this));

        this.dropDown = new DropDown(this.btn.DOMElement,'share-dropdown',{note: true});
        // if (!isMobile) {
        this.dropDown.overflow = this.overflow;
        this.dropDown.overflowStopSelector = isMobile ? '#app' : '#ui';
        // }

        this.dropDown.setCustomHandler(() => {});
        this.dropDown.create();
        const socialMedia = [
            {
                "type": "copy",
                "title": "Copy",
                "icon": "icon-copy-regular"
            },
            {
                "type": "whatsapp",
                "title": "whatsApp",
                "icon": "icon-whatsapp"
            },
            {
                "type": "fb",
                "title": "Facebook",
                "icon": "icon-FACEBOOK"
            },
            {
                "type": "email",
                "title": "Email",
                "icon": "icon-email"
            }
        ];

        socialMedia.forEach(social => {
            const scope = new ShareBtn(null,{
                    type: social.type,
                    url: this.url
                },social.icon,social.title,social.type === 'copy' ? this.#copyToClipboard.bind(this) : null,
                this.dropDown);

            this.dropDown.add(scope.btn.DOMElement);
        });

        this.dropDown.arrowBlock.classList.add('hidden');

        isMobile && this.#addSwipe(this.dropDown.curtain,this.dropDown);

    }

    #addSwipe(element,scope) {
        let dragStarted = false;
        let panDirection = null;
        let state;

        const swipe = new Hammer.Manager(element);
        swipe.add(new Hammer.Pan({
            threshold: 10
        }));

        const panHandler = (direction) => {
            switch (direction) {
                case 'panup':
                    element.parentElement.style.bottom = '';
                    break;
                case 'pandown':
                    scope.hide();
                    break;
            }
            dragStarted = false;
            panDirection = null;
            setTimeout(() => {
                if (!dragStarted) {
                    element.parentElement.style.bottom = '';
                }
            },400);
        };

        swipe.on('panstart',() => {
            state = element.parentElement.getBoundingClientRect();
        });


        swipe.on('panup pandown', (e) => {
            const position = clamp(e.deltaY * -1,state.height * -1,0);
            element.parentElement.style.bottom = `${position}px`;
            panDirection = e.additionalEvent;
            dragStarted = true;
            if (e.isFinal) {
                panHandler(panDirection);
            }
        });

        swipe.on('panend', () => {
            if (dragStarted && panDirection) {
                panHandler(panDirection);
            }
        });
    }

    #copyToClipboard(e) {
        e.stopPropagation();
        const dir = getCurrentLangDirection();
        Notiflix.Notify.merge({
            position: isDesktop ? 'left-top' : (dir === 'ltr') ? 'right-top' : 'left-top',
            timeout: 1000,
            rtl: (dir !== 'ltr')
        });
        
        function oldCopy (url) {
            const textArea = document.createElement('textarea');
            textArea.value = url;
            textArea.style.position = 'fixed';
    
            document.body.appendChild(textArea);
            textArea.focus();
            textArea.select();
    
            try {
                const successful = document.execCommand('copy');
                if (successful) {
                    Notiflix.Notify.success(changeLangToCurrent('Link Copied'));
                } else {
                    Notiflix.Notify.failure('Oops, unable to copy');
                }
            } catch (err) {
                Notiflix.Notify.failure('Oops, unable to copy');
            }
    
            document.body.removeChild(textArea);
        }

        if (!navigator.clipboard) {
            oldCopy(this.url);
            return;
        }

        navigator.clipboard.writeText(this.url)
            .then(() =>  Notiflix.Notify.success(changeLangToCurrent('Link Copied')))
            .catch(() => oldCopy(this.url));
        this.dropDown.hide();
    }

    #openHandler(e) {
        e.stopPropagation();
        if (this.overflow) {
            this.dropDown.findParent();
        }
        !isMobile && this.dropDown.setOpenPosition(this.position);
        this.dropDown.show();

        // this.mediaContainer = createHtmlElement(document.body,'','div',['social-media']);
        // const content = createHtmlElement(this.mediaContainer,'','div',['social-media__content']);
        // this.closeBtn = createHtmlElement(this.mediaContainer,'','button',['social-media__close-btn','icon-close']);

        // const media = config.features.socialMedia.media;
        // media.forEach(social => new ShareBtn(content,{
        //     type: social.type,
        //     url: this.url
        // },social.icon));

        // this.closeBtn.addEventListener('click', this.closeHandler);
        // this.mediaContainer.addEventListener('click', this.closeHandler);
    }

    // #closeHandler() {
    //     this.closeBtn.removeEventListener('click',this.closeHandler);
    //     this.mediaContainer.removeEventListener('click', this.closeHandler);
    //     this.mediaContainer.remove();
    // }

    addClass(...value) {
        if (!Boolean(this.btn))
            return;

        this.btn.addClass(...value);
    }

    // #closeHandler() {
    //     this.closeBtn.removeEventListener('click',this.closeHandler);
    //     this.mediaContainer.removeEventListener('click', this.closeHandler);
    //     this.mediaContainer.remove();
    // }

    addClass(...value) {
        if (!Boolean(this.btn))
            return;

        this.btn.addClass(...value);
    }
}

export class ShareBtn {
    constructor (parent, attributes, icon, text,handler,dropdownScope) {
        this.parent = parent;
        this.dropdownScope = dropdownScope;
        this.text = text;
        this.attributes = attributes;
        this.icon = icon;
        this.handler = handler || this.#share.bind(this);
        this.#addButton();
    }

    #addButton() {
        this.btn = new BaseElement()
            .addClass('social-btn',this.attributes.type);

        if (this.icon) {
            new BaseElement()
                .addClass('social-btn__icon',this.icon)
                .appendTo(this.btn.DOMElement);
        }

        if (this.text) {
            new BaseElement('span')
                .addClass('social-btn__text','language-string')
                .addAttribute('data-dictionary',this.text)
                .innerHtml(changeLangToCurrent(this.text))
                .appendTo(this.btn.DOMElement);
        }

        if (this.parent) {
            this.btn.appendTo(this.parent);
        }

        Object.entries(this.attributes).forEach(([key,value]) => {
            this.btn.addAttribute(`data-${key}`,value);
        });

        this.btn.event('click', this.handler);
    }

    #share(e) {
        e.stopPropagation();

        if (isMobile || isTablet) {

            const shareData = {
                url: this.btn.getAttribute('data-url'),
                text: '',
                title: config.projectTitle
            };

            navigator.share(shareData);

        } else {
            JSShare.go(this.btn.DOMElement);
        }

        if (this.dropdownScope) {
            this.dropdownScope.hide();
        }
    }

}
